import { saveManager } from './SaveManager';

const LAST_SCENE_KEY = 'apogee-hold-last-scene-v1';

export type RestorableScene = 'Menu' | 'Command' | 'Battle';

/**
 * Refresh restore is a cold-boot affordance only. Once Menu has been created
 * in this page load, later navigations (Command → Menu, Pause → MAIN MENU)
 * must stay put so the player can reach save slots.
 */
let sessionAutoResumeArmed = true;

export function consumeSessionAutoResume(): boolean {
  if (!sessionAutoResumeArmed) return false;
  sessionAutoResumeArmed = false;
  return true;
}

/** Persist which deck the commander was on so a refresh can restore it. */
export function rememberScene(scene: RestorableScene): void {
  try {
    localStorage.setItem(LAST_SCENE_KEY, JSON.stringify({ scene, at: Date.now() }));
    if (scene !== 'Battle') {
      // Leaving combat is intentional; do not force a battle resume later.
      if (saveManager.data.activeRun && scene === 'Menu') {
        // Keep the checkpoint for Continue, but auto-resume only mid-sortie.
      }
    }
  } catch { /* storage unavailable */ }
}

export function lastScene(): RestorableScene | null {
  try {
    const raw = localStorage.getItem(LAST_SCENE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { scene?: string };
    if (parsed.scene === 'Battle' || parsed.scene === 'Command' || parsed.scene === 'Menu') return parsed.scene;
    return null;
  } catch {
    return null;
  }
}

/**
 * True when a browser refresh should drop the commander back into the live
 * sortie instead of the title screen.
 */
export function shouldAutoResumeSortie(): boolean {
  if (typeof localStorage === 'undefined') return false;
  if (localStorage.getItem('apogee-hold-intro-seen-v1') !== '1') return false;
  if (!saveManager.data.commanderName) return false;
  if (!saveManager.data.activeRun) return false;
  return lastScene() === 'Battle';
}
